import { useEffect, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { Field, ImageField, MetaLine, SaveButton, inputCls } from "../../components/admin/fields";
import { RichTextEditor } from "../../components/admin/RichTextEditor";

export default function SiteSettingsPage() {
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get("/admin/site-settings").then((res) => setForm(res.data)).catch(() => {});
  }, []);

  if (!form) return <p className="eyebrow">Loading…</p>;

  const set = (key) => (e) => {
    setForm((f) => ({ ...f, [key]: e && e.target ? e.target.value : e }));
    setSaved(false);
  };

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.put("/admin/site-settings", form);
      setForm(data);
      setSaved(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={save} className="max-w-3xl space-y-10" data-testid="admin-settings-form">
      <div className="flex items-center justify-between">
        <h1 className="h-condensed text-4xl">Site Settings</h1>
        <MetaLine by={form.updated_by} at={form.updated_at} />
      </div>

      <div className="grid gap-6 sm:grid-cols-2">
        <Field label="Footer address — London">
          <input value={form.footer_address || ""} onChange={set("footer_address")} className={inputCls} data-testid="settings-address" />
        </Field>
        <Field label="Copyright line">
          <input value={form.copyright_line || ""} onChange={set("copyright_line")} className={inputCls} data-testid="settings-copyright" />
        </Field>
        <Field label="LinkedIn URL">
          <input value={form.linkedin_url || ""} onChange={set("linkedin_url")} className={inputCls} data-testid="settings-linkedin" />
        </Field>
        <Field label="Instagram URL">
          <input value={form.instagram_url || ""} onChange={set("instagram_url")} className={inputCls} data-testid="settings-instagram" />
        </Field>
        <Field label="SPV link URL">
          <input value={form.spv_url || ""} onChange={set("spv_url")} className={inputCls} data-testid="settings-spv-url" />
        </Field>
        <Field label="A Bunch Of Stuff link URL">
          <input value={form.abos_url || ""} onChange={set("abos_url")} className={inputCls} data-testid="settings-abos-url" />
        </Field>
      </div>

      <div className="grid gap-6 sm:grid-cols-2">
        <ImageField label="SPV logo" value={form.spv_logo} onChange={set("spv_logo")} testid="settings-spv-logo" />
        <ImageField label="A Bunch Of Stuff logo" value={form.abos_logo} onChange={set("abos_logo")} testid="settings-abos-logo" />
      </div>

      <Field label="Privacy Policy (published at /privacy-policy)">
        <RichTextEditor value={form.privacy_policy} onChange={set("privacy_policy")} testid="settings-privacy-editor" />
      </Field>
      <Field label="Terms of Service (published at /terms-of-service)">
        <RichTextEditor value={form.terms_of_service} onChange={set("terms_of_service")} testid="settings-terms-editor" />
      </Field>

      <div className="flex items-center gap-6 border-t border-charcoal pt-6">
        <SaveButton busy={busy} dirty={!saved} />
        {saved && <span className="text-xs font-light opacity-60" data-testid="settings-saved">Saved.</span>}
        {error && <p className="text-sm" role="alert">{error}</p>}
      </div>
    </form>
  );
}
